import { useContext } from 'react'
import { ThemeContext } from './../lib/ThemeProvider'
// import B2CTheme from '../token/theme/B2CTheme'
import CleartripTheme from '@ct-design/token/theme/CleartripTheme'

const useTheme = () => {
    const themeContext = useContext(ThemeContext)
    const { theme } = themeContext || CleartripTheme

    return theme
}

export default useTheme
